export default {
    // 修改主导航激活状态
    changeNavName(context, name) {
        context.commit('changeNavName', name);
    },
    // 修改面包屑导航条内容
    changeCrumb(context, data) {
        context.commit('changeCrumb', data);
    },
    changeBatt(context, data) {
        context.commit('changeBatt', data);
    },
}